const state = {
  sidebar: {
    opened: true
  }
}

const mutations = {
  TOGGLE_SIDEBAR: state => {
    state.sidebar.opened = !state.sidebar.opened
  },
  CLOSE_SIDEBAR: state => {
    state.sidebar.opened = false
  },
  OPEN_SIDEBAR: state => {
    state.sidebar.opened = true
  }
}

const actions = {
  toggleSidebar({ commit }) {
    commit('TOGGLE_SIDEBAR')
  },
  closeSidebar({ commit }) {
    commit('CLOSE_SIDEBAR')
  },
  openSidebar({ commit }) {
    commit('OPEN_SIDEBAR')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
